import Phaser from 'phaser';
import { BootScene } from './game/scenes/BootScene';
import { PreloadScene } from './game/scenes/PreloadScene';
import { MenuScene } from './game/scenes/MenuScene';
import { GameScene } from './game/scenes/GameScene';
import { GameOverScene } from './game/scenes/GameOverScene';
import { GAME, COLORS } from './game/config/gameConfig';

/**
 * Zenith - Mobile Physics Puzzle Game
 * Main entry point and Phaser game configuration
 */

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: GAME.WIDTH,
  height: GAME.HEIGHT,
  backgroundColor: COLORS.BACKGROUND,
  physics: {
    default: 'matter',
    matter: {
      gravity: { x: 0, y: GAME.GRAVITY },
      debug: GAME.DEBUG_PHYSICS,
    },
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME.WIDTH,
    height: GAME.HEIGHT,
  },
  scene: [BootScene, PreloadScene, MenuScene, GameScene, GameOverScene],
};

// Create the game instance
const game = new Phaser.Game(config);

// Export for debugging purposes in development
if (import.meta.env.DEV) {
  (window as unknown as { game: Phaser.Game }).game = game;
}

export default game;
